<template lang="pug">
  v-card(class="pa-4")

    div(v-show="showSimpleLoading")
      SimpleLoading

    v-row
      v-col(cols="12")
        h2(class="grey--text text--darken-2") {{ $t('multiAxisChart.TITLE') }}
    v-row(justify="center")

      v-col(v-show="!isDataEmpty" sm="12" xs="12" md="12" lg="10" xl="10")
        apexchart(:options="options" :series="options.series" ref="multiChart")

      v-col(v-show="isDataEmpty" sm="12" xs="12" md="12" lg="10" xl="10")
        h4(class="text-center grey--text") {{ $t('multiAxisChart.NODATA') }}
    ErrorMessage
</template>

<script>
import SimpleLoading from '@/components/core/SimpleLoading.vue'

// import pt_BR from "vee-validate/dist/locale/pt_BR.json";
// import en from "vee-validate/dist/locale/en.json";
// import es from "vee-validate/dist/locale/es.json";

export default {
  data: function(){
        return {
          isDataEmpty: false,
          showSimpleLoading: false,

          options: {
                colors : [this.$vuetify.theme.themes.light.primary, this.$vuetify.theme.themes.light.secondary], // verde: 2ECC71, amarelo: FBC531, azul: 1B9CFC
                series: [{
                  name: `${this.$t('multiAxisChart.VIEWS')}`,
                  type: 'line',
                  data: []
                },
                {
                  name: `${this.$t('multiAxisChart.USERS')}`,
                  type: 'area',
                  data: []
                }],
                chart: {
                  height: 250,
                  type: 'area',
                  toolbar: {
                    show: false
                  },
                },
                // plotOptions: {
                //   bar: {
                //     columnWidth: '38%',
                //     distributed: false
                //   }
                // },
                fill: {
                  colors : ['#1B9CFC', '#2ECC71'],
                },
                stroke: {
                  width: [4, 4], // espessura da linha
                  curve: 'smooth', // straight
                  dashArray: [0, 0] // pontilhado da linha
                },
                title: {
                  text: '' // título do gráfico
                },
                dataLabels: { // quadrados com número
                  enabled: false,
                  enabledOnSeries: [0]
                },
                labels: [],
                xaxis: {
                  type: 'datetime',
                },
                yaxis: [{
                  title: {
                    text: '', // título esquerda
                    //text: `${this.$t('multiAxisChart.VIEWS')}`, // título esquerda
                  },
                }],
                markers: {
                  size: 0, // bolinhas
                   strokeColors: '#fff',
                   strokeWidth: 0,
                   strokeOpacity: 0.9,
                   strokeDashArray: 0,
                   fillOpacity: 1,
                   hover: {
                     size: 4,
                     sizeOffset: 3
                   },
                },

        }
    }
  },
  components: {
    SimpleLoading
  },
  methods:{

    mountChart(){
      this.showSimpleLoading = true
      if(this.$refs.multiChart != null){
        this.$refs.multiChart.updateOptions({
            locales: this.$store.getters.locale,
            series: [
              {
              name: `${this.$t('multiAxisChart.VIEWS')}`,
              type: 'area',
              data: this.chartData.pageviews
              },
              {
              name: `${this.$t('multiAxisChart.USERS')}`,
              type: 'area',
              data: this.chartData.users
              }
            ],
            labels: this.chartData.labels
        })
      }
      this.showSimpleLoading = false
      // this.options = {...this.options, ...{
      //     series: [{
    }

  },
  computed: {
    chartData () {
        if(this.$store.state.adminDash.multiAxisChart.pageviews !== undefined && this.$store.state.adminDash.multiAxisChart.pageviews.length == 0){
          this.isDataEmpty = true
        }else{ this.isDataEmpty = false }
        return this.$store.state.adminDash.multiAxisChart
    },
    lang(){
      return this.$store.getters.locale
    }
  },

  watch: {
    //chartData (newData, oldData) {
    chartData (){
      //console.log('watched-chart-data: '+this.chartData)
      this.mountChart()
    },
    //lang (newLang, oldLang) { // se trocou a linguagem, remonta o gráfico
    lang () {
      console.log('lang-chart-data: '+this.chartData)
      this.mountChart()
    }
  }

}

</script>
